// extracted by mini-css-extract-plugin
export var AuthorAvatar = "author-module--AuthorAvatar--270c9";
export var AuthorBio = "author-module--AuthorBio--db974";
export var AuthorLabel = "author-module--AuthorLabel--f76c2";
export var AuthorLeft = "author-module--AuthorLeft--bb427";
export var AuthorText = "author-module--AuthorText--56193";
export var AuthorWrapper = "author-module--AuthorWrapper--6d8ef";